// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"623":"cc6012af","976":"e862f41b"}[chunkId] + ".chunk.js";
};